module.exports = __webpack_public_path__ + "media/图1-10动画.bd61bb11.mp4";